/**
 * @module components/TableFieldSetting
 * @description 表格字段设置（Phase 5 迁移 — 入口组件）
 *
 * 内含 UrlSetting(URL字段设置) + FieldColumnSorting(字段列排序)
 * 子组件状态管理已各自迁移至 Context
 */

import React from 'react';
import { useIntl } from 'umi';
import ConfigCollapseCard from '@/pages/datalab/components/ConfigCollapseCard';
import UrlSetting from './UrlSetting';
import FieldColumnSorting from './FieldColumnSorting';
import './index.scss';

const TableFieldSetting: React.FC = () => {
  const { formatMessage } = useIntl();
  return (
    <ConfigCollapseCard title={formatMessage({ id: 'dbl_chart_primary_field_setting' })} className="dbl-table-field-setting">
      <UrlSetting />
      <FieldColumnSorting />
    </ConfigCollapseCard>
  );
};

export default React.memo(TableFieldSetting);
